import { dayChange, tileColor, NEUTRAL } from './heatmap';
import { toNumber } from './format';

// «Рынок сегодня», leaders and sectors (docs/market-overview/SPEC.md), counted from the heatmap answer:
// only IMOEX shares, the day change as on the map.

export const LEADERS = 5;

function indexShares(items) {
  return items
    .filter((i) => i.in_index)
    .map((i) => ({ ...i, change: dayChange(i.price, i.prev_close) }))
    .filter((i) => i.change !== null);
}

// Breadth (decision 6): «без изменений» are the grey tiles of the map, |change| < 0.01 %.
export function breadth(items) {
  const counts = { up: 0, down: 0, flat: 0 };
  for (const share of indexShares(items)) {
    if (tileColor(share.change) === NEUTRAL) {
      counts.flat += 1;
    } else if (share.change > 0) {
      counts.up += 1;
    } else {
      counts.down += 1;
    }
  }
  return { ...counts, total: counts.up + counts.down + counts.flat };
}

// Up to five shares that grew (or fell) the most; a share counted as still in the breadth is in neither list.
export function leaders(items, direction) {
  const sign = direction === 'up' ? 1 : -1;
  return indexShares(items)
    .filter((s) => s.change * sign > 0 && tileColor(s.change) !== NEUTRAL)
    .sort((a, b) => (b.change - a.change) * sign)
    .slice(0, LEADERS);
}

// A sector's change is the average of its shares with index weights; sorted from the best day down.
export function sectors(items) {
  const sums = new Map();
  for (const share of indexShares(items)) {
    const weight = toNumber(share.index_weight);
    if (weight === null || weight <= 0) {
      continue;
    }
    const key = share.industry?.sector ?? 'other';
    const sum = sums.get(key) ?? { weighted: 0, weight: 0, count: 0 };
    sum.weighted += share.change * weight;
    sum.weight += weight;
    sum.count += 1;
    sums.set(key, sum);
  }
  return [...sums.entries()]
    .map(([key, s]) => ({ key, change: s.weighted / s.weight, count: s.count }))
    .sort((a, b) => b.change - a.change);
}
